import { withClassNames } from '~/styles'
import { TermsAndConditions } from '../components/LegalPolicies/TermsAndConditions'
import s from './terms-conditions.module.scss'
const cx = withClassNames(s)

export const TermsAndConditionsWrapper = () => {
  return (
    <div className={cx('terms-container')}>
      <TermsAndConditions hide={() => null} showButton={false} />
    </div>
  )
}
